import { put, takeEvery, select } from 'redux-saga/effects'
import { COUPON_LOADING, GET_COUPON_DATA_SUCCESS, GET_COUPON_DATA_ERROR, COUPON_END_LOADING } from "../actions/actionCoupon";
import { GET_TOURPRODUCT_DATA_SUCCESS } from "../actions/actionTourProduct";
import { SHOPCART_APPLYCOUPON_TO_EVENTS, SHOPCART_APPLYCOUPON_TO_GATICKETS, SHOPCART_APPLYCOUPON_TO_MEMBERSHIP_PACKAGE } from "../actions/actionShopCart";
import { START_POST_UNIQUECOUPON_HOLDS_SUCCESS, START_POST_UNIQUECOUPON_HOLDS_ERROR } from "../actions/actionUniqueCouponHolds";
import { getCouponProducts } from 'api';
import { apiTourProduct } from 'api';
import Moment from 'moment';
import { genfunction } from 'helpers';
import { uniqueCouponPost } from 'api';
import { CouponManager } from 'helpers';
import { RestaurantMenu } from '@material-ui/icons';

const { CouponExpiryMsg, MaxTimesCouponUsed, OneCouponAllowedForMembership, NewMembershipNotAllowed, RenewMembershipNotAllowed } = window['runConfig'];

async function fetchAsync(func, code) {

    const response = await func(code);
    if (response.ok && response.statusText !== 'No Content') {
        return await response.json();
    }
    if (response.status == 400) {
        let error = await response.json();
        throw new Error("Unable to apply Coupon, " + error.Errors[0].ErrorMessage.replace('Error: ', ''));
    }
    else if (response.status == 202 || response.status == 204) {
        return "nocontent";
    }
    else if (response.statusText === 'Unauthorized') {
        throw new Error("Authorization has been denied for this request.");
    }
    else {
        throw new Error("Unable to apply Coupon, response : " + response.statusText + " - " + response.status)
    }
}

function* fetchCouponData(action) {
    try {
        const couponData = null;
        let bookingCoupons = [];

        let events = yield select(state => state.reducerShopCart.events);
        let membershipPackages = yield select(state => state.reducerShopCart.MembershipPackages);
        let gaTickets = yield select(state => state.reducerShopCart.GATickets);

        let couponv3Data = yield fetchAsync(getCouponProducts, action.coupnCode);
        if (couponData == undefined && couponv3Data == undefined
            && couponData.length == 0 && couponv3Data.length == 0) {
            throw new Error("Coupon Code not found, please try again with an valid Coupon Code.");
        }
        else if (couponv3Data && couponv3Data.length > 0 && couponv3Data[0].GATickets) {
            let isCouponValid = false;

            gaTickets.map(ticket => {
                let couponproduct = couponv3Data[0].GATickets.find(x => x.ProductID === ticket.ProductID);
                if (couponproduct)
                    isCouponValid = true

            })
            if (isCouponValid) {
                yield put({ type: GET_COUPON_DATA_SUCCESS, payload: couponv3Data });
                yield put({ type: SHOPCART_APPLYCOUPON_TO_GATICKETS, payload: { GATickets: couponv3Data[0].GATickets, CouponCode: action.coupnCode } });
            }
            else
                yield put({ type: GET_COUPON_DATA_ERROR, error: "Coupon Code not found against " + ( gaTickets.length == 1 ? "this ticket." : "these tickets.") });
        }
        else if (couponv3Data && couponv3Data.length > 0 && couponv3Data[0].MembershipPackages && membershipPackages && membershipPackages.length > 0) {
            
            const membershipPackages = yield select(state => state.reducerShopCart.MembershipPackages);
            const membershipIsRenew = yield select(state => state.reducerShopCart.membershipIsRenew);

            let membershippackID = membershipPackages && membershipPackages.length > 0 ? membershipPackages[0].MembershipPackageID : 0;
            let apiMembershipPackage = genfunction.GetMembershipPackageFromApi(couponv3Data, membershippackID);

            if (apiMembershipPackage === null || apiMembershipPackage.MembershipPackageID !== membershippackID) {
                yield put({ type: GET_COUPON_DATA_ERROR, error: "Coupon Code not found against this membership package, please try again with an valid Coupon Code." });
            }
            else {
                if (apiMembershipPackage.AllowDiscountOnJoin == false && membershipIsRenew == false) {
                    yield put({ type: GET_COUPON_DATA_ERROR, error: NewMembershipNotAllowed });
                }
                else if (apiMembershipPackage.AllowDiscountOnRenewal == false && membershipIsRenew) {
                    yield put({ type: GET_COUPON_DATA_ERROR, error: RenewMembershipNotAllowed });
                }
                else {
                    if (membershipPackages && membershipPackages[0].MembershipProducts && membershipPackages[0].MembershipProducts.filter(x => x.CouponCodeApplied).length == 0) {
                        yield put({ type: GET_COUPON_DATA_SUCCESS, payload: couponv3Data });
                        yield put({ type: SHOPCART_APPLYCOUPON_TO_MEMBERSHIP_PACKAGE, payload: { MembershipPackages: apiMembershipPackage, CouponCode: action.coupnCode } });
                    }
                    else {
                        yield put({ type: GET_COUPON_DATA_ERROR, error: OneCouponAllowedForMembership });
                    }
                }
            }
        }
        else if (couponv3Data && couponv3Data.length > 0 && couponv3Data[0].TourProducts && events && events.length > 0) {
            var couponFrom = genfunction.ReturnDateOnly(couponv3Data[0].UseCouponFrom);
            var couponTill = genfunction.ReturnDateOnly(couponv3Data[0].UseCouponTill);
            var CurrentDateTimeAtLocation = genfunction.ReturnDateOnly(couponv3Data[0].CurrentDateTimeAtLocation);

            if (CurrentDateTimeAtLocation >= couponFrom && CurrentDateTimeAtLocation <= couponTill) {

                let applyDisProdID = couponv3Data[0].TourProducts && couponv3Data[0].TourProducts.length > 0 ? couponv3Data[0].TourProducts[0].ApplyDiscountToTourProductID : 0;

                const data = yield fetchAsync(apiTourProduct, applyDisProdID);
                yield put({ type: GET_TOURPRODUCT_DATA_SUCCESS, payload: data });

                let couponHoldRef = '';
                if (couponv3Data[0].RequireUniqueCouponCode) {

                    if (couponv3Data[0].MaxProductsPerPurchase < 1) {
                        yield put({ type: GET_COUPON_DATA_ERROR, error: "Please check your unique coupon configuration, Max User Per Day must be greater than 0." });
                        return;
                    }

                    if (couponv3Data[0].TimesUsed >= couponv3Data[0].MaxTransactionsPerCoupon) {
                        yield put({ type: START_POST_UNIQUECOUPON_HOLDS_ERROR, error: MaxTimesCouponUsed });
                        return;
                    }

                    //Generate UniqueCouponHold Request
                    let uniqueCouponObj = CouponManager.UniqueCouponPostRequest(couponv3Data[0], events, bookingCoupons);

                    if (uniqueCouponObj.Error.length > 0) {
                        yield put({ type: START_POST_UNIQUECOUPON_HOLDS_ERROR, error: MaxTimesCouponUsed });
                        return;
                    }

                    let uniqueCouponHoldsRes = yield fetchAsync(uniqueCouponPost, uniqueCouponObj.UniqueCoupon[0]);

                    if (uniqueCouponHoldsRes == "nocontent") throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to apply unique coupon.\"}]}"
                    else {
                        couponHoldRef = uniqueCouponHoldsRes[0].CouponHoldRef;
                        yield put({ type: START_POST_UNIQUECOUPON_HOLDS_SUCCESS, payload: uniqueCouponHoldsRes });
                    }
                }

                yield put({ type: SHOPCART_APPLYCOUPON_TO_EVENTS, tourCoupon: couponv3Data, tourProduct: data, couponCode: action.coupnCode, CouponHoldRef: couponHoldRef });
                yield put({ type: GET_COUPON_DATA_SUCCESS, payload: couponv3Data });
            }
            else {
                yield put({ type: GET_COUPON_DATA_ERROR, error: CouponExpiryMsg });
            }
        }
        else {
            yield put({ type: GET_COUPON_DATA_ERROR, error: "Coupon Code not found, please try again with an valid Coupon Code." });
        }
    } catch (e) {
        yield put({ type: GET_COUPON_DATA_ERROR, error: e.message });
    }
}


export const sagaCoupon = [
    takeEvery(COUPON_LOADING, fetchCouponData)
];
